import { documentosSelector } from "features/Documentos/redux/documentosSlice"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useState } from "react"

/* eslint-disable @typescript-eslint/no-explicit-any */
export const useFilterMenu = <TTotales = undefined>({
  serviceCall,
  serviceAdapter,
  initialQuery,
}: $TSMigrationFixMe) => {
  const [items, setItems] = useState<Array<object>>([])
  const [isLoading, setIsLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [totales, setTotales] = useState<TTotales>()

  const [serviceQuery, setServiceQuery] = useState<any>(initialQuery)
  const [error, setError] = useState(false)
  const { isVerDocumentoModalShowing } = useSelector(documentosSelector)

  const fetchTableData = useCallback(async () => {
    try {
      setIsLoading(true)
      const res = await serviceCall()?.(serviceQuery)
      const tableData = serviceAdapter ? serviceAdapter(res) : res.items || res
      setTotales(res?.totales)
      setTotalCount(res?.totalCount)
      setItems(tableData)
      return tableData
    } catch (e) {
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }, [serviceQuery, serviceCall, serviceAdapter])

  useEffect(() => {
    fetchTableData()
  }, [fetchTableData, isVerDocumentoModalShowing, serviceQuery])

  return {
    items,
    isLoading,
    totalCount,
    totales,
    serviceQuery,
    error,
    setServiceQuery,
    setIsLoading,
    fetchTableData,
  }
}
